import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span>
          &copy; <a href="https://www.happyquest.co">HappyQuest</a> 2018-2019.
        </span>
        <span className="ml-auto">

        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js